module.exports = __webpack_public_path__ + "img/me-small.c6cf6f2a.png";